import { type ListTemplateLayout } from "components/ListTemplate/types";
import React from "react";
import { ExtractorSessionTitle } from "./ExtractorSessionTitle";
import { ExtractorSessionFlightsTable } from "./ExtractorSessionFlightsTable";

export const cardLayout = (): ListTemplateLayout<server.dto.ExtractorSession> => ({
  type: "card",
  sections: {
    renderTitle: item => <ExtractorSessionTitle item={item} />,
    hideTitle: () => false,
    renderBody: item => <ExtractorSessionFlightsTable item={item} />,
    renderFooter: () => null,
    hideFooter: () => true,
  }
});